import Vue from 'vue'
import Cookies from 'js-cookie'
import VueRouter from 'vue-router'
import storeMixin from '@/mixins/store-mixin';

import Home from '@/views/Home.vue'
import Login from '@/views/Login';
import ModifyCancelDonation from '@/views/ModifyCancelDonation';
import ReviewPastDonations from '@/views/ReviewPastDonations';
import Register from '@/views/Register';
import DonorInformation from '@/views/DonorInformation';
import Donations from '@/views/Donations';
import Contact from '@/views/Contact';
import DonationDropBox from '@/views/DonationDropBox';
import AboutUs from '@/views/AboutUs';
import FAQ from '@/views/FAQ';
import AcceptableItems from '@/views/AcceptableItems';
import Privacy from '@/views/Privacy';
import ChangePassword from '@/views/ChangePassword';
import VizavanceReceipt from '@/views/VizavanceReceipt';
import FDReceipt from '@/views/FDReceipt';
import Confirm from '@/views/Confirm';

import store from '@/store/index';

Vue.use( VueRouter );

const routes = [
	{ path: '/', name: 'default', component: Login },
	{ path: '/login', name: 'login', component: Login },
	{ path: '/ec1', name: 'ec1', component: Login },
	{ path: '/ec2', name: 'ec2', component: Login },
	{ path: '/ec3', name: 'ec3', component: Login },
	{ path: '/ec4', name: 'ec4', component: Login },
	{ path: '/ec5', name: 'ec5', component: Login },
	{ path: '/ec6', name: 'ec6', component: Login },
	{ path: '/ec7', name: 'ec7', component: Login },
	{ path: '/ec8', name: 'ec8', component: Login },
	{ path: '/ec9', name: 'ec9', component: Login },
	{ path: '/ec10', name: 'ec10', component: Login },
	{ path: '/ec11', name: 'ec11', component: Login },
	{ path: '/ec12', name: 'ec12', component: Login },
	{ path: '/ec13', name: 'ec13', component: Login },
	{ path: '/ec14', name: 'ec14', component: Login },
	{ path: '/ec15', name: 'ec15', component: Login },
	{ path: '/modify-cancel-donation', name: 'modify-cancel-donation', component: ModifyCancelDonation },
	{ path: '/review-past-donations', name: 'review-past-donations', component: ReviewPastDonations },
	{ path: '/register', name: 'register', component: Register },
	{ path: '/donations', name: 'donations', component: Donations },
	{ path: '/donor-information', name: 'donor-information', component: DonorInformation },
	{ path: '/contact', name: 'contact', component: Contact },
	// { path: '/donation-drop-box', name: 'donation-drop-box', component: DonationDropBox },
	{ path: '/home', name: 'home', component: Home },
	{ path: '/about-us', name: 'about-us', component: AboutUs },
	{ path: '/faq', name: 'faq', component: FAQ },
	{ path: '/acceptable-items', name: 'acceptable-items', component: AcceptableItems },
	{ path: '/privacy', name: 'privacy', component: Privacy },
	{ path: '/change-password', name: 'change-password', component: ChangePassword },
	{ path: '/vizavance-receipt', name: 'vizavance-receipt', component: VizavanceReceipt, props: true },
	{ path: '/fd-receipt', name: 'fd-receipt', component: FDReceipt, props: true },
	{ path: '/confirm', name: 'confirm', component: Confirm }
];

const router = new VueRouter( {
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior( to, from, savedPosition ) {
		return { x: 0, y: 0 }
	}
} );

router.beforeEach( ( to, from, next ) => {
	let isLoggedIn = store.getters.isLoggedIn;
	let pickupExists = store.getters.pickupExists;

	let openDivs = document.getElementsByClassName( 'open' );
	let openNavDivs = document.getElementsByClassName( 'nav-open' );
	for ( const div of openNavDivs ) {
		div.classList.remove( 'nav-open' );
	}
	for ( const div of openDivs ) {
		div.classList.remove( 'open' );
	}
	let openDivsCheck = document.getElementsByClassName( 'open' );
	if ( openDivsCheck.length > 0 ) {
		for ( const div of openDivsCheck ) {
			div.classList.remove( 'open' );
		}
	}

	//redirect
	if( to.name === 'home' ){
		window.location.href = "https://donationpickup.org";
	}else if( to.name === 'contact' ){
		window.location.href = "https://donationpickup.org/contact";
	}else if( to.name === 'about-us' ){
		window.location.href = "https://donationpickup.org";
	}else if( to.name === 'faq' ){
		window.location.href = "https://donationpickup.org/faqs/";
	}else if( to.name === 'acceptable-items' ){
		window.location.href = "https://donationpickup.org/acceptable-items/";
	}else if( to.name === 'privacy' ){
		window.location.href = "https://donationpickup.org/privacy/";
	}else if( to.name.startsWith('ec') ){
		let ecNumber = to.name.toUpperCase()
		window.location.href = redirectUtmCode(ecNumber);
	}

	if ( to.name === 'donations' || to.name === 'modify-cancel-donation' || to.name === 'review-past-donations' || to.name === 'donor-information' ) {
		//console.log('TO:' + to.name)
		//next();
		if ( !isLoggedIn && ( isLoggedIn !== undefined || true ) ) {
			let queryString = to.fullPath.split('?')[1] || ''
			if( queryString !== '' ){
				next( '/login?'+queryString )
			}else{
				next( '/login' )
			}

		} else {
			next()
		}
	} else {
		next()
	}
} );

function redirectUtmCode(ec){
	return "https://dp.donationpickup.org/login?utm_source=donationpickup&utm_medium=sms&utm_campaign=pickup_reminder_" + ec + "_v1&utm_content=sms_link";;
}


export default router
